import React from "react";
import PropTypes from 'prop-types';
import {VictoryBar, VictoryChart, VictoryAxis, VictoryLabel} from "victory";
import utils from '../../lib/utils';
import colors from '../../constants/colors';

export class SubmissionsKpiDataChart extends React.Component {
  formatData(data) {
    let formattedData = [];
    if (Object.keys(data).includes('funded_dollars')) {
      const goalVal =
        data.funded_dollars.goal_accurate ? data.funded_dollars.goal : null;
      formattedData = [
        {
          text_label: 'Target',
          dollars: utils.getValueFormDollarizedString(goalVal)
        },
        {
          text_label: 'Actual',
          dollars: utils.getValueFormDollarizedString(data.funded_dollars.value)
        }
      ];
    }
    return formattedData;
  }

  hasFundedDollarsData() {
    const data = this.props.data;
    return !!data.funded_dollars;
  }

  determineLabels() {
    const data = this.props.data;
    if (this.hasFundedDollarsData()) {
      return (
        (data.funded_dollars.goal === "$0" && data.funded_dollars.value === "$0") ?
          ['', ''] : [data.funded_dollars.goal, data.funded_dollars.value]
      );
    }
  }

  renderNoDataMessage() {
    const data = this.props.data;
    if (this.hasFundedDollarsData()) {
      return (
        (data.funded_dollars.goal === "$0" && data.funded_dollars.value === "$0") ?
          'No data available' : ''
      );
    }
  }

  render() {
    const dataToRenderBars = this.formatData(this.props.data);
    return (
      <div className="submissions-kpi-data-chart">
        <div className="submissions-kpi-data-chart__inner-wrap">
          <div className="submissions-kpi-data-chart__chart-wrap">
            <div className="submissions-kpi-data-chart__chart-label">
              <span>
                {`Volume($)`}
              </span>
            </div>
            <div className="submissions-kpi-data-chart__chart">
              <VictoryChart
                animate={{
                  duration: 500,
                  easing: "polyOut"
                }}
                domainPadding={120}
                padding={{top: 0, bottom: 75, left: 25, right: 25}}
                >
                <VictoryBar
                  data={dataToRenderBars}
                  x="text_label"
                  y="dollars"
                  labels={this.determineLabels()}
                  labelComponent={<VictoryLabel className="dollar-label"/>}
                  style={{
                    data: {
                      fill: (d) => d.x === "Target" ? "var(--main-color)" : "var(--secondary-color)",
                      width: 150
                    },
                    labels: {
                      fill: (d) => d.x === "Target" ? "var(--main-text)" : "var(--secondary-text)",
                      fontFamily: "var(--font)",
                      fontSize: 30
                    }
                  }}
                />
                <VictoryAxis
                  orientation={"top"}
                  offsetY={225}
                  tickFormat={["Target", "Actual"]}
                  tickValues={[1, 2]}
                  tickLabelComponent={<VictoryLabel dy={40} className="axis-label"/>}
                  style={{
                    tickLabels: {
                      fontFamily: "var(--font)",
                      fontSize: 20,
                      fill: "var(--axis-text)",
                      offsetY: 10
                    },
                    axis: {stroke:"var(--axis-text)"}
                  }}
                />
                <text x={150} y={125}>{this.renderNoDataMessage()}</text>
              </VictoryChart>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SubmissionsKpiDataChart.propTypes = {
  data: PropTypes.object,
};

export default SubmissionsKpiDataChart;
